import { CookieStorage } from 'aws-amplify/utils';
import { Cookies } from 'react-cookie';

interface CookieStorageOptions {
	secure?: boolean; // Add the 'secure' option
	domain?: string;
}

const keyConversion: any = {
	idToken: 'aws_cognito_id_token',
	accessToken: 'aws_cognito_access_token',
	refreshToken: 'aws_cognito_refresh_token',
	expiresIn: 'aws_cognito_expires_in',
	email: 'aws_cognito_email_address',
	LastAuthUser: 'aws_cognito_last_auth_user',
};

export class CustomCookieStorage extends CookieStorage {
	private cookies: Cookies;

	constructor(options: CookieStorageOptions = {}) {
		super(options);
		this.cookies = new Cookies();
	}

	override getItem(key: string): any {
		const cookieKey: string | undefined = key.split('.')[3];
		if (!cookieKey) {
			return;
		}

		const cookieName = keyConversion[cookieKey] || key;
		const cookieValue = this.cookies.get(cookieName);
		return cookieValue || null;
	}

	override setItem(key: string, value: string): any {
		const cookieKey = key.split('.')[3];
		if (!cookieKey) {
			return;
		}

		const cookieName = keyConversion[cookieKey];
		if (!cookieName) {
			return;
		}

		if (this.domain) {
			// Remove cookies created by older builds without a Domain attribute.
			this.cookies.remove(cookieName, { path: '/' });
		}
		const currentValue = this.cookies.get(cookieName);

		if (currentValue !== value) {
			this.cookies.set(cookieName, value, {
				path: '/',
				domain: this.domain,
				secure: this.secure,
				sameSite: 'strict',
			});
		}

		if (cookieKey !== 'signInDetails') {
			if (this.domain) {
				this.cookies.remove('aws_cognito_token_type', { path: '/' });
			}
			const tokenType = this.cookies.get('aws_cognito_token_type');
			if (tokenType !== 'Bearer') {
				this.cookies.set('aws_cognito_token_type', 'Bearer', {
					path: '/',
					domain: this.domain,
					secure: this.secure,
					sameSite: 'strict',
				});
			}
		}
	}

	override removeItem(key: string): any {
		const cookieKey: string | undefined = key.split('.')[3];
		if (!cookieKey) return;
		const cookieName = keyConversion[cookieKey] || key;
		if (this.domain) {
			this.cookies.remove(cookieName, { path: '/', domain: this.domain });
		}
		this.cookies.remove(cookieName, { path: '/' });
	}
}
